
const styles = theme => ({
  btn: {
    display: "inline-block",
    '&:hover': {
      transition: theme.transitions.create('', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen * 2,
      }),
    },
  },
  date: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    fontSize: '.8rem',
    fontFamily: "Rubik, Oswald",
  },
  alignBtn: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
    paddingTop: '48px !important',
    paddingBottom: '40px !important',
    '& a': {
      display: 'inline-block',
      width: '100%',
      maxWidth: '355px',
      '& >div':{
        '& >div': {
          '& img': {
            height: 'auto',
            objectFit: 'contain',
            width: '100%',
          }
        }
      }
    }
  },
  portSearch: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0px',
  }
});

export default styles;
